import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { Specialty, SpecialtyCode } from '../../../../domain/entities';

type MedicalCenter = 'sauces' | 'duran' | undefined;

interface Props {
  specialties: Specialty[];
  specialty?: Specialty;
  onSpecialtyChanged: (event: SelectChangeEvent<SpecialtyCode>) => void;
  medicalCenter?: MedicalCenter;
  onMedicalCenterChanged: (event: SelectChangeEvent<MedicalCenter>) => void;
}

const DoctorExtraFields = ({
  specialties,
  specialty,
  onSpecialtyChanged,
  medicalCenter,
  onMedicalCenterChanged
}: Props) => {
  return (
    <>
      <FormControl margin='normal' fullWidth>
        <InputLabel id='specialty-label'>Especialidad</InputLabel>
        <Select
          labelId='specialty'
          id='specialty-select'
          value={specialty?.code}
          label='Especialidad'
          onChange={onSpecialtyChanged}
        >
          {specialties.map((specialty) => (
            <MenuItem key={specialty.code} value={specialty.code}>
              {specialty.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl margin='normal' fullWidth>
        <InputLabel id='medical-center-label'>Centro Médico</InputLabel>
        <Select
          labelId='medical-center'
          id='medical-center-select'
          value={medicalCenter}
          label='Centro Médico'
          onChange={onMedicalCenterChanged}
        >
          <MenuItem value={'sauces'}>Sauces</MenuItem>
          <MenuItem value={'duran'}>Durán</MenuItem>
        </Select>
      </FormControl>
    </>
  );
};

export default DoctorExtraFields;
